import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"

import { Col, Container, Row, UncontrolledTooltip } from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"

import TableContainer from "../../components/Common/TableContainer"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//import Images

import DeleteModal from "./DeleteModal"

//css
import "@fullcalendar/bootstrap/main.css"

//redux
import { useSelector, useDispatch } from "react-redux"
import { Link, useHistory } from "react-router-dom"
import {
  getTodaysAppointments,
  fetchAppointmentTypes,
  getUserDetails,
  getAppointmentsByDocId,
  getAppointmentsOfDoc,
  setAppointmentsOfDoctor,
  setGlobalLoading,
} from "store/slices"
import { getAppointmentsByWeek, modifyEventsData } from "helpers/utils"
import {
  BillingName,
  NumberVal,
  OrderId,
  StatusName,
  Time,
  Total,
} from "pages/Pets/components/PatientsCol"
import { deleteAppointment } from "helpers/api_helper"
import { IconSVG } from "components/Common/IconSvg"
//calender buttons css
import "../../assets/scss/custom/components/_calender.scss"
import { Date, Parent } from "pages/Parents/components/PatientsCol"
import LeftArrow from "../../assets/icons/ArrowLeft.png"
import moment from "moment"
import { convertTo12HourFormat } from "helpers/commonHelpers"
import RescheduleAppointmentModal from "components/Appointments/RescheduleAppointmentModal"
import { filterAndSortAppointments } from "./appointmentHistory"

const AllAppointments = props => {
  //meta title
  document.title = "Appointment History | Supaw"

  const dispatch = useDispatch()

  const [event, setEvent] = useState({})
  const [currentSelected, setCurrentSelected] = useState(-1)

  // events validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (event && event.title) || "",
      category: (event && event.category) || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Your Event Name"),
      category: Yup.string().required("Please Select Your Category"),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateEvent = {
          id: event.id,
          title: values.title,
          classNames: values.category + " text-white",
          start: event.start,
        }
        // update event
        dispatch(onUpdateEvent(updateEvent))
        validation.resetForm()
      } else {
        const newEvent = {
          id: Math.floor(Math.random() * 100),
          title: values["title"],
          start: selectedDay ? selectedDay.date : new Date(),
          className: values.category + " text-white",
        }
        // save new Appointment
        dispatch(onAddNewEvent(newEvent))
        validation.resetForm()
      }
      setSelectedDay(null)
      //   toggle()
    },
  })

  const appointments = useSelector(getAppointmentsOfDoc) || []
  const [search, setSearch] = useState("")
  const [sortBy, setSortBy] = useState("newest")
  const visibleAppointments = useMemo(
    () => filterAndSortAppointments(appointments, search, sortBy),
    [appointments, search, sortBy]
  )
  const userDetails = useSelector(getUserDetails)
  const [deleteModal, setDeleteModal] = useState(false)
  const [isDeleting, setIsdeleting] = useState(false)
  const [rescheduleAppointmentData, setRescheduleAppointmentData] = useState(null)
  const history = useHistory();

  useEffect(() => {
    dispatch(fetchAppointmentTypes())
  }, [dispatch])

  useEffect(() => {
    async function fetchData() {
      if (userDetails?._id) {
        dispatch(setGlobalLoading(true))
        await dispatch(getAppointmentsByDocId(userDetails?._id))
        dispatch(setGlobalLoading(false))
      }
    }
    fetchData()
  }, [dispatch, userDetails?._id])

  const handleDateClick = arg => {}

  /**
   * Handling click on event on calendar
   */
  const handleDeleteEvent = async () => {
    try {
      setIsdeleting(true)
      const res = await deleteAppointment(currentSelected)
      if (res.status == 1) {
        await dispatch(getAppointmentsByDocId(userDetails?._id))
      }
      setIsdeleting(false)
      setDeleteModal(false)
    } catch (error) {
      setIsdeleting(false)
      setDeleteModal(false)
    }
  }

  console.log(appointments, "appointmentsappointments")

  /**
   * On delete event
   */
  const handleEventClick = arg => {
    history.push(`/edit-appointment/${arg.event._def.publicId}`)
  }

  const onClickDelete = arg => {
    // dispatch(onDeleteEvent(event))
    setCurrentSelected(arg._id)
    setDeleteModal(true)
    // toggle()
  }
  // const Parent = cell => {
  //   return (
  //     <Link to={`/parent/${cell.value}`}>{cell.value ? cell.value : ""}</Link>
  //   )
  // }

  const PatientName = cell => {
    return (
      <Link
        to={cell.row?.original?.petObjectId?._id ? `/pet/${cell.row.original.petObjectId._id}` : `/appointment/${cell.row.original._id}`}
        className="font-fontFamily"
      >
        {cell.value ? cell.value : ""}
      </Link>
    )
  }

  const DateModified = cell => {
    // if (cell.value) {
    //   const datePart = cell.value.split("T")[0]
    //   return datePart
    // }
    // return ""
    //xpecto Devloper 13/8/2024
    if (cell.value) {
      console.log("cell.value????", cell.value)

      // Split the date and time parts
      const datePart = cell.value.split("T")[0]

      // Split the date into components
      const [year, month, day] = datePart.split("-")

      // Reformat to dd-mm-yyyy
      const formattedDate = `${day}-${month}-${year}`

      return formattedDate
    }
    return ""
    //xpecto Devloper 13/8/2024
  }
  const Cost = cell => {
    if (typeof cell.value === "number") {
      return "Rs " + Number(cell.value)
    }
    return ""
  }

  const columns = useMemo(
    () => [
      {
        Header: "Patient",
        accessor: "petObjectId.fullName",
        filterable: true,
        Cell: cellProps => (
          <div>
            <PatientName {...cellProps} />
            <div className="appointment-history__muted">
              {[cellProps.row.original?.petObjectId?.petType, cellProps.row.original?.petObjectId?.petBreed].filter(Boolean).join(" · ") || "Pet details unavailable"}
            </div>
          </div>
        ),
      },
      {
        Header: "Pet Parent",
        accessor: "parentId.fullName",
        filterable: true,
        Cell: cellProps => {
          return <Parent {...cellProps} />
        },
      },
      {
        Header: "Appointment",
        accessor: "date",
        filterable: true,
        Cell: cellProps => {
          const item = cellProps.row.original
          return (
            <div>
              <div>{item.date ? moment(item.date).format("DD MMM YYYY") : "Date unavailable"}</div>
              <div className="appointment-history__muted">{item.time ? convertTo12HourFormat(item.time) : "Time unavailable"}</div>
            </div>
          )
        },
      },
      {
        Header: "Booked At",
        accessor: "createdAt",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? moment(cellProps.value).format("DD MMM YYYY, hh:mm A") : "—"
        },
      },
      {
        Header: "Service",
        accessor: "visitType",
        filterable: true,
        Cell: cellProps => (
          <div className="appointment-history__service-cell">
            <div>{cellProps.value || cellProps.row.original?.type || "Appointment"}</div>
            {cellProps.row.original?.consultationCategory === "FREE" && (
              <span className="free-consultancy-badge mt-1">
                <span className="free-consultancy-badge__dot" aria-hidden="true" />
                Free Consultancy
              </span>
            )}
          </div>
        ),
      },
      // {
      //   Header: "Visits",
      //   accessor: "visits",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return <NumberVal {...cellProps} />
      //   },
      // },
      {
        Header: "Fee",
        accessor: "cost",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value != null ? `₹${cellProps.value}` : "—"
        },
      },
      {
        Header: "Status",
        accessor: "status",
        filterable: true,
        Cell: cellProps => {
          const value = String(cellProps.value || "Unknown")
          return <span className={`appointment-history__status appointment-history__status--${value.toLowerCase()}`}>{value}</span>
        },
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="appointment-history__actions">
              <Link to={`/appointment/${cellProps.row.original._id}`} className="appointment-history__action-button appointment-history__action-button--details" title="View appointment details, parent documents and prescription">
                <i className="mdi mdi-file-document-outline" aria-hidden="true" />
                <span>Details &amp; Documents</span>
              </Link>
              {cellProps.row.original.status === "scheduled" &&
              cellProps.row.original.status !== "completed" ? (
                <Link
                  to={`/edit-appointment/${cellProps.row.original._id}`}
                  className="text-info"
                  title="Edit appointment"
                >
                  <IconSVG icon="edit" />
                </Link>
              ) : null}
              {["scheduled", "rescheduled", "accepted"].includes(
                String(cellProps.row.original.status || "").trim().toLowerCase()
              ) ? (
                <button
                  type="button"
                  className="btn btn-link text-info p-0 border-0"
                  onClick={() => setRescheduleAppointmentData(cellProps.row.original)}
                  title="Reschedule"
                >
                  <IconSVG icon="reschedule" />
                </button>
              ) : null}
              <Link
                to={`/prescription-details/${cellProps.row.original._id}`}
                className="appointment-history__action-button appointment-history__action-button--prescription"
                title="View prescription"
              >
                <i className="mdi mdi-prescription" aria-hidden="true" />
                <span>Prescription</span>
              </Link>
              {cellProps.row.original.status !== "completed" &&
                cellProps.row.original.status !== "cancelled" && (
                  <Link
                    to={`${
                      cellProps.row.original.status === "checkIn"
                        ? "prescription"
                        : "checkin"
                    }/${cellProps.row.original._id}`}
                    className="text-success"
                    title={cellProps.row.original.status === "checkIn" ? "Create prescription" : "Check in"}
                  >
                    <IconSVG icon="checkin" />
                  </Link>
                )}

              <Link
                to="#"
                className="text-danger"
                title="Delete appointment"
                onClick={() => {
                  const appointmentData = cellProps.row.original
                  onClickDelete(appointmentData)
                }}
              >
                <IconSVG icon="delete" />
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  //Filter todays appoitment data

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        isDeleting={isDeleting}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />
      <RescheduleAppointmentModal
        isOpen={Boolean(rescheduleAppointmentData)}
        appointmentData={rescheduleAppointmentData}
        onClose={() => setRescheduleAppointmentData(null)}
        onSuccess={async updatedAppointment => {
          if (updatedAppointment?._id) {
            dispatch(setAppointmentsOfDoctor(
              appointments.map(item =>
                item?._id === updatedAppointment._id ? updatedAppointment : item
              )
            ))
          }
          await dispatch(getAppointmentsByDocId(userDetails?._id))
          await dispatch(getTodaysAppointments())
        }}
      />

      <div className="page-content">
        <Container fluid={true}>
          <Row className=" mb-4 ">
            <Col className="d-flex align-items-center justify-content-start gap-2">
              <img
                src={LeftArrow}
                width={36}
                onClick={() => history.goBack()}
                role="button"
              />
              <h4 className="mb-0 font-fontFamily fontSize-36">
                Appointment History
              </h4>
            </Col>

            <Col className="d-flex justify-content-end mt-4">
              <div className="create-link">
                <Link
                  color="primary"
                  className="font-16 btn-block font-fontFamily"
                  to={"/add-appointment"}
                >
                  <i className="mdi mdi-plus-circle-outline me-1 mr-2" />
                  Create New Appointment
                </Link>
              </div>
            </Col>
          </Row>
          {/* <div className="appointment-heading-div"><h4 className="mb-sm-0 font-size-18"><img
                src={LeftArrow}
                width={25}
                onClick={() => history.goBack()}
                role="button"
              />All Appointments</h4>
          <div className="create-link">
                <Link
                  color="primary"
                  className="font-16 btn-block"
                  to={"/add-appointment"}
                >
                  <i className="mdi mdi-plus-circle-outline me-1" />
                  Create New Appointment
                </Link>
              </div>
          </div> */}
          <Row>
            <Col className="col-12">
              {/* <div className="create-link">
                <Link
                  color="primary"
                  className="font-16 btn-block"
                  to={"/add-appointment"}
                >
                  <i className="mdi mdi-plus-circle-outline me-1" />
                  Create New Appointment
                </Link>
              </div> */}
              {/* <Row style={displayCalender}>
                <Col className="col-lg-12">
                  <FullCalendar
                  className="custom-header"
                    plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                    slotDuration={"00:30:00"}
                    handleWindowResize={true}
                    themeSystem="bootstrap"
                    headerToolbar={{
                      left: "dayGridMonth,dayGridWeek,dayGridDay",
                      right: "prev,next title",
                    }}
                    events={modifiedEventsByDay}
                    selectable={true}
                    dateClick={handleDateClick}
                    eventColor= '#FAFAFA'
                    // eventClick={handleEventClick}
                    eventContent={({ event }) => (
                      <div className="calender-event-container">
                        <div className="calender-total-appointments">{event.title}</div>
                        <div className="calender-appointment-timings-div">
                        {event.extendedProps.times.map((time, index) => (
                          <span key={index} onClick={() => handleNav(event.extendedProps.events[index].id)} className="calender-appointment-timings">
                            {time},
                          </span>
                        ))}
                        </div>
                      </div>
                    )}
                  />
                </Col>
              </Row> */}
              <div className="appointment-history__table-card mt-4">
                {/* <div className="appointment-header-container">
                  <div className="today-appointment-heading">Today's Appointment</div>
                  <div className="all-apointment-link-div">All Appointments <img src={navigateForword} alt="forword"/></div></div> */}
                <div className="appointment-history__toolbar">
                  <h5 className="mb-0">Appointments</h5>
                  <span className="appointment-history__muted">{visibleAppointments.length} of {appointments.length} appointments</span>
                </div>
                <TableContainer
                  toolbar={(
                    <div className="appointment-history__filters">
                      <input
                        type="search"
                        className="form-control"
                        aria-label="Search by pet or parent name"
                        placeholder="Search pet or parent name"
                        value={search}
                        onChange={event => setSearch(event.target.value)}
                      />
                      <select className="form-select" aria-label="Sort appointment history"
                        value={sortBy} onChange={event => setSortBy(event.target.value)}>
                        <option value="newest">Newest appointment</option>
                        <option value="oldest">Oldest appointment</option>
                        <option value="pet-asc">Pet name A–Z</option>
                        <option value="pet-desc">Pet name Z–A</option>
                        <option value="parent-asc">Parent name A–Z</option>
                        <option value="parent-desc">Parent name Z–A</option>
                      </select>
                    </div>
                  )}
                  columns={columns}
                  data={visibleAppointments}
                  isGlobalFilter={false}
                  isAddOptions={false}
                  emptyListLink="/add-appointment"
                  emptyText="No Appointments found"
                  emptyLinkText="+ Add Appointment"
                  customPageSize={10}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AllAppointments.propTypes = {
  events: PropTypes.array,
  categories: PropTypes.array,
  className: PropTypes.string,
  onGetEvents: PropTypes.func,
  onAddNewEvent: PropTypes.func,
  onUpdateEvent: PropTypes.func,
  onDeleteEvent: PropTypes.func,
  onGetCategories: PropTypes.func,
}

export default AllAppointments
